<template>
  <div class="min-h-screen bg-surface">
    <slot name="header">
      <AM3CreateHeader
        :action-button-text="actionButtonText"
        :action-button-icon="actionButtonIcon"
        :secondary-button-text="secondaryButtonText"
        :submit-form-id="submitFormId"
        @exit="emit('exit')"
        @secondary-action="emit('secondary-action')"
        @action="emit('action')"
      />
    </slot>

    <div
      v-if="showContent"
      class="flex min-h-[calc(100vh-64px)] max-[860px]:flex-col"
    >
      <div class="flex flex-col flex-1 bg-white max-[860px]:max-w-[100vw] max-[860px]:min-h-full">
        <slot name="left" />
      </div>
      <div
        class="w-1/2 max-w-[700px] sticky top-[76px] h-[calc(100vh-76px)] overflow-y-auto xl:max-w-[460px] 2xl:max-w-[598px] min-[1600px]:max-w-[700px] max-[860px]:relative max-[860px]:top-auto max-[860px]:h-auto max-[860px]:max-h-none max-[860px]:min-w-0 max-[860px]:w-full max-[860px]:overflow-y-visible max-[860px]:pt-[30px] max-[860px]:px-3 max-[860px]:pb-[106px]"
        :class="rightPanelClass"
      >
        <slot name="right" />
      </div>
    </div>
    <!-- Rendered instead of the panels - e.g. campaign edit's "not found" error state -->
    <slot
      v-else
      name="fallback"
    />
  </div>
</template>

<script setup lang="ts">
import AM3CreateHeader from './AM3CreateHeader.vue'

interface Props {
  actionButtonText?: string
  actionButtonIcon?: string
  secondaryButtonText?: string
  submitFormId: string
  /** Extra classes for the right panel - e.g. a gradient background */
  rightPanelClass?: string
  /** Whether the left/right panel content renders at all - lets a consumer show
   * a full-bleed loading state instead (used by the campaign edit page) */
  showContent?: boolean
}

withDefaults(defineProps<Props>(), {
  actionButtonText: 'Save',
  actionButtonIcon: '',
  secondaryButtonText: '',
  rightPanelClass: 'bg-surface',
  showContent: true,
})

const emit = defineEmits<{
  'exit': []
  'secondary-action': []
  'action': []
}>()
</script>

<style scoped>
/* The one piece of shared styling Tailwind utilities can't express here:
`.form-content` is an element each consumer renders inside the `left` slot
(not this component's own template), so it needs `:slotted()` rather than a
plain class rule - Vue scoped CSS otherwise wouldn't match it. */
:slotted(.form-content) {
  flex: 1;
  padding: 50px 80px;
  overflow-y: auto;
}

@media (max-width: 860px) {
  :slotted(.form-content) {
    padding: 30px 12px;
    height: 100%;
  }
}
</style>
